module.exports = __webpack_public_path__ + "media/images/desktop-9816a30a3346d710c89c550c6e533f1d.png";